
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Constants } from '../../common/constants';

@Injectable({
  providedIn: 'root'
})
export class TeamService {




  private apiUrl = `${Constants.baseUrl}/api/Employee`; // Adjust this URL based on your API setup

  constructor(private http: HttpClient) { }

  // Fetch all team members
  // getTeamMembers(): Observable<any[]> {
  //   return this.http.get<any[]>(`${this.apiUrl}`)
  //     .pipe(
  //       catchError(this.handleError<any[]>('getTeamMembers', []))
  //     );
  // }

  // Fetch employee by ID
  getEmployeeById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`)
      .pipe(
        catchError(this.handleError<any>(`getEmployeeById id=${id}`))
      );
  }

  getActiveEmployeeStatus(empId: number): Observable<boolean> {
    return this.http.get<any>(`${this.apiUrl}/status/${empId}`);
     
  }
  
  
  

  // Handle HTTP operation errors
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // console.error(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }


  
  private teamData = [
    {
      name: 'Vani Maganti',
      designation: 'Advisor',
      image: 'assets/images/team/leader/vani.jpg',
      linkedin: 'https://www.linkedin.com/in/maganti/',
      empId:'209'
    },
    {
      name: 'Venkat Maganti',
      designation: 'Advisor',
      image: 'assets/images/team/leader/venkatMaganti.jpg',
      linkedin: 'https://www.linkedin.com/in/maganti/',
       empId:'268'
    },
    {
      name: 'Pavan Kumar GN',
      designation: 'Sr. Account Manager',
      image: 'assets/images/team/newdev-images/pavan.jpg',
      linkedin: 'https://www.linkedin.com/in/pavan-kumar-gurram/',
     empId:'268'
    },
    {
      name: 'Srinivas M',
      designation: 'Sr. Account Manager',
      image: 'assets/images/team/leader/srinivasRao.jpg',
      linkedin: 'https://www.linkedin.com/in/srinivas-m-68514b1b1/',
      empId:'268'
    },
    {
      name: 'Nagoor Shaik',
      designation: 'Sr. Application Developer',
      image: 'assets/images/team/newdev-images/Nagoor.JPG',
      linkedin: 'https://www.linkedin.com/in/nagoor-shaik-3a911370/',
      empId:'045'
    },
    // Add the remaining team members in a similar format
    {
      name: 'Arun Kumar Mareedu',
      designation: 'Sr. Application Developer',
      image: 'assets/images/team/development/arun1.jpg',
      linkedin: 'https://www.linkedin.com/in/arun-mareedu-a169b18a/',
      empId:'077'
    },
    {
      name: 'Venkateswararao N',
      designation: 'Sr. Application Developer',
      image: 'assets/images/team/newdev-images/Venkateswara rao Nagasetti.JPG',
      linkedin: 'https://www.linkedin.com/in/venkat-n-8246211a4/',
      empId:'268'
    },
    {
      name: 'Rakesh Manduri',
      designation: 'Facility Manager',
      image: 'assets/images/team/newdev-images/Rakesh M.jpg',
      linkedin: 'https://www.linkedin.com/in/rakeshmanduri/',
      empId:'118'
    },
    {
      name: 'Rama Krishna Parimi',
      designation: 'Sr. Application Developer',
      image: 'assets/images/team/newdev-images/Ramakrishna.jpg',
      linkedin: 'https://www.linkedin.com/in/rama-krishna-7846201a4/',
      empId:'120'
    },
    {
      name: 'Anil Pavuluri',
      designation: 'Sr. Application Developer',
      image: 'assets/images/team/newdev-images/Anil P.jpg',
      linkedin: 'https://www.linkedin.com/in/anil-pavuluri-5836231a4/',
      empId:'125'
    },
    {
      name: 'Narasimha Rao Vunnam',
      designation: 'Sr. Application Developer',
      image: 'assets/images/team/newdev-images/Narasimha.jpg',
      linkedin: 'https://www.linkedin.com/in/narasimha-rao-vunnam-nv-a6a824150/',
      empId:'129'
    },
    {
      name: 'Anjaneyulu Raavi',
      designation: 'SME, Accounting Services',
      image: '/assets/images/team/newdev-images/Anji.jpg',
      linkedin: 'https://www.linkedin.com/in/anjaneyulu-raavi-158941195/',
      empId:'134'
    },
    {
      name: 'Mahesh Venkat K',
      designation: 'Application Developer - I',
      image: 'assets/images/team/newdev-images/Mahesh.JPG',
      linkedin: 'https://www.linkedin.com/in/mahesh-karnati-5266361a4/',
      empId:'268'
    },
  
    {
      name: 'Raju K',
      designation: 'Business Development Manager',
      image: 'assets/images/team/newdev-images/Raju.JPG',
      linkedin: 'https://www.linkedin.com/in/raju-k-b0871b1a1/',
      empId:'268'
    },
    {
      name: 'Bheemesh Tarappagol',
      designation: 'Sr. Application Developer',
      image: 'assets/images/team/development/bheemeshTarappagol.jpg',
      linkedin: 'https://www.linkedin.com/in/mwlite/in/bheemesh-tarappagol-86580336',
      empId:'268'
    },
  
    {
      name: 'Siva Kiran Nekkalapu',
      designation: '.NET Developer',
      image: 'assets/images/team/development/sivaKiran.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'268'
    },
    {
      name: 'V S Surendar Gubba',
      designation: 'Software Quality Engineer- I',
      image: 'assets/images/team/newdev-images/Surendra.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'158'
    },
    {
      name: 'K S S Sruthi',
      designation: 'Lead, Content Developer',
      image: 'assets/images/team/newdev-images/SruthiK.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'163'
    },
    {
      name: 'Suresh Pothuraju',
      designation: 'Database Engineer - II',
      image: 'assets/images/team/newdev-images/Suresh Pothuraju.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'157'
    },
    {
      name: 'Rajababu Gottumukkala',
      designation: 'Project Manager',
      image: 'assets/images/team/newdev-images/Raja Babu.JPG',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'159'
    },
    {
      name: 'Naveen Kumar Karla',
      designation: 'SharePoint Developer/ Administrator',
      image: 'assets/images/team/development/default.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'268'
    },
    {
      name: 'Kavya Bandaru',
      designation: 'Application Test Automation Developer',
      image: 'assets/images/team/development/default.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'268'
    },
    {
      name: 'S S K Suryadevara',
      designation: 'AEM Developer',
      image: 'assets/images/team/development/default.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'268'
    },
    {
      name: 'Mukesh Garapati',
      designation: 'JAVA Developer',
       image: 'assets/images/team/development/default.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:''
    },
   
    {
      name: 'Baji Ghantasala',
      designation: 'Creative Executive',
      image: 'assets/images/team/newdev-images/Baji.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'160'
    },
    {
      name: 'Abhishek Patra',
      designation: 'Software Engineer',
      image: 'assets/images/team/newdev-images/Abhishek.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'167'
    },
    {
      name: 'Hemant Patar',
      designation: 'Application Developer - I',
      image: 'assets/images/team/newdev-images/Hemanth P.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'171'
    },
    {
      name: 'Syed Mahaboob Idris',
      designation: 'Software Quality Engineer - I',
      image: 'assets/images/team/newdev-images/Idris.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'175'
    },
    {
      name: 'Nazia Shaik',
      designation: 'Product Coordinator',
      image: 'assets/images/team/newdev-images/Nazia.JPG',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'178'
    },
    {
      name: 'Vishal Ravindra Bethi',
      designation: 'Application Developer - III',
      image: 'assets/images/team/newdev-images/Vishal Ravindar Bethi.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'180'
    },
    {
      name: 'Sai Krishna N',
      designation: 'Lead, Digital Marketing',
      image: 'assets/images/team/newdev-images/Vamsi Krishna.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'162'
    },
    {
      name: 'Upendra Pamulapati',
      designation: 'Application Developer - II',
      image: 'assets/images/team/newdev-images/Upendra.JPG',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
       empId:'183'
    },
    // {
    //   name: 'Geetha Madhuri Manduri',
    //   designation: 'Data Entry',
    //   image: 'assets/images/team/newdev-images/geetha.jpg',
    //   linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
    //   empId:'193'
    // },
    {
      name: 'Usha Medikonda',
      designation: 'Cloud Engineer',
      image: 'assets/images/team/newdev-images/Usha M.JPG',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'195'
    },
    {
      name: 'Nameera Unissa',
      designation: 'Software Quality Engineer - II',
      image: 'assets/images/team/newdev-images/Nameera.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'198'
    },
    {
      name: 'Sasikanth Pasumarthi',
      designation: 'Software Quality Engineer - I',
      image: '  assets/images/team/newdev-images/Sasi.JPG',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'196'
    },
    {
      name: 'Sainadh Vechha',
      designation: 'Salesforce Engineer',
      image: 'assets/images/team/newdev-images/Sainadh V.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'201'
    },
    {
      name: 'Koteswara Rao Bejawada',
      designation: 'Application Developer - III',
      image: 'assets/images/team/newdev-images/Koteswararao.jpg',
      linkedin: 'https://www.linkedin.com/in/kirannekkalapu/',
      empId:'203'
    },
    {
      name: 'Nikhil Sai Ghattamaneni',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Nokhil.jpg',
      linkedin: 'https://www.linkedin.com/in/ghattamaneni-nikhil-sai-82258a16b/',
      empId:'204'
    },
    {
      name: 'Bala S. Ammanamanchi',
      designation: 'Business Development Executive',
      image: 'assets/images/team/newdev-images/Bala Subramanyam.JPG',
      linkedin: 'https://www.linkedin.com/signup/cold-join',
      empId:'205'
    },
    {
      name: 'Madhu Sai Santhosh Siddhani',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Madhu.JPG',
      linkedin: 'https://www.linkedin.com/in/siddhanimadhu/',
      empId:'208'
    },
    {
      name: 'Dimple Reena Munipalli',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Dimple Reena.JPG',
      linkedin: 'https://www.linkedin.com/in/dimplemit/',
      empId:'209'
    },
    {
      name: 'Naga Poojitha Mareedu',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Poojitha.JPG',
      linkedin: 'https://www.linkedin.com/in/mareedu-poojitha-b976b0246/',
      empId:'212'
    },
    {
      name: 'Harika Kaki',
      designation: 'Business Development Executive',
      image: 'assets/images/team/newdev-images/Harika K.jpg',
      linkedin: 'https://www.linkedin.com/in/harika-reddy/',
      empId:'214'
    },
    {
      name: 'Venkateswarlu Gopathi',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Venkateswarlu.JPG',
      linkedin: 'https://www.linkedin.com/in/venkateswarlu-gopathi-b480b3236/',
      empId:'213'
    },
    {
      name: 'Shoba Rani Katakam',
      designation: 'Flutter Developer',
      image: 'assets/images/team/newdev-images/Shobarani.jpg',
      linkedin: 'https://www.linkedin.com/in/shoba-rani-bb29b7211/',
      empId:'215'
    },
    {
      name: 'Saikiran Maturi',
      designation: 'Cloud Engineer',
      image: 'assets/images/team/newdev-images/saikiranmaruti.jpg',
      linkedin: 'https://www.linkedin.com/in/sai-kiran-maturi-1665b9185/',
      empId:'219'
    },
    {
      name: 'Jagadeesh Pagolu',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Jagadish.jpg',
      linkedin: 'https://www.linkedin.com/signup/cold-join',
      empId:'216'
    },
    {
      name: 'Devendar Anumolu',
      designation: 'Scrum Master',
      image: 'assets/images/team/development/default.jpg',
      linkedin: 'https://www.linkedin.com/in/anumolu-devender-76892555/',
      empId:'230'
    },
    // {
    //   name: 'Bhanu Gongada',
    //   designation: 'Cloud Engineer',
    //   image: 'assets/images/team/newdev-images/Bhanu.JPG',
    //   linkedin: 'https://www.linkedin.com/in/bhanu-gongada-5a9607157/',
    //   empId:'223'
    // },
    {
      name: 'Nitish Kumar Garikapati',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Nitish Kumar Garikapati.JPG',
      linkedin: 'https://www.linkedin.com/in/nitish-kumar-garikapati-8b2882227/',
      empId:'225'
    },
    {
      name: 'Narendra Reddy K',
      designation: 'Application Developer',
      image: 'assets/images/team/newdev-images/Narendra K.jpg',
      linkedin: 'https://www.linkedin.com/in/narendra-reddy-kandula-301740213',
      empId:'227'
    },
    {
      name: 'A S V Sharan Kumar',
      designation: 'Jr. Database Engineer',
      image: 'assets/images/team/newdev-images/Sharan.jpg',
      linkedin: 'https://www.linkedin.com/in/a-s-v-sharan-kumar-617759243',
      empId:'268'
    },
    // {
    //   name: 'Narendra Babu M',
    //   designation: 'Business Development Executive',
    //   image: 'assets/images/team/newdev-images/Narendra.jpg',
    //   linkedin: 'https://www.linkedin.com/in/hemant-patar/',
    //   empId:'231'
    // },
    {
      name: 'Baburaju Jagathab',
      designation: 'Digital Marketing Executive',
      image: 'assets/images/team/newdev-images/Baburaju.jpg',
      linkedin: 'https://www.linkedin.com/in/babu-raj-928612261/',
      empId:'232'
    },
    {
      name: 'Dhana Lakshmi M',
      designation: 'Jr. Test Engineer',
      image: 'assets/images/team/newdev-images/Dhana Lakshmi.JPG',
      linkedin: 'https://www.linkedin.com/in/dhanalakshmi-medikonda-859282240/',
      empId:'234'
    },
    {
      name: 'Kiran Kumar Avula',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Kiran Avula.JPG',
      linkedin: 'https://www.linkedin.com/in/avula-kiran-kumar-47603924a/',
      empId:'233'
    },
    {
      name: 'Yeswanth Kumar Vema',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Yaswanth Kumar.JPG',
      linkedin: 'https://www.linkedin.com/in/yaswanth-vema-33026479/',
      empId:'238'
    },
    {
      name: 'Nagarjuna Ravi',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Nagarjuna.jpg',
      linkedin: 'https://www.linkedin.com/in/nagarjuna-ravi-088a12266/',
      empId:'242'
    },
    {
      name: 'Sravani Doddapaneni',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Sriavani Doddapaneni.jpg',
      linkedin: 'https://www.linkedin.com/in/sravani-d-07b161277/',
      empId:'239'
    },
    {
      name: 'Sandeep Gurajala',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Sandeep.jpg',
      linkedin: 'https://www.linkedin.com/in/sandee-gurajala-0710sp0817/',
      empId:'240'
    },
    {
      name: 'Ashok Vangala',
      designation: 'Jr. Test Engineer',
      image: 'assets/images/team/newdev-images/Ashok.jpg',
      linkedin: 'https://www.linkedin.com/in/ashok-vangala-2b9a4791/',
      empId:'241'
    },
    // {
    //   name: 'Harsha Pondugula',
    //   designation: 'Jr. Application Developer',
    //   image: 'assets/images/team/newdev-images/Harsha.jpg',
    //   linkedin: 'https://www.linkedin.com/in/harsha-pondhugula-466776261/',
    //   empId:'268'
    // },
    {
      name: 'Samuel Sekhar Tadala',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Samuel.jpeg',
      linkedin: 'https://www.linkedin.com/in/samuel-tadala-541379117',
      empId:'244'
    },
    // {
    //   name: 'Vijaya Raghava Lingala',
    //   designation: 'US IT Recruiter',
    //   image: 'assets/images/team/newdev-images/vijay.png',
    //   linkedin: 'https://www.linkedin.com/in/vijay-r-a854581ba',
    //   empId:'245'
    // },
    // {
    //   name: 'Sambaraju Uardi',
    //   designation: 'UI/UX Designer',
    //   image: 'assets/images/team/newdev-images/Sambaraju.png',
    //   linkedin: 'https://www.linkedin.com/in/sambaraju-uaradi-397b49172/',
    //   empId:'246'
    // },
    {
      name: 'Perungulam Madhava',
      designation: 'Sr. Talent Acquisition Specialist',
      image: 'assets/images/team/newdev-images/Madhava.png',
      linkedin: 'https://www.linkedin.com/in/madhav-perungulam-95715b2b/',
      empId:'247'
    },
    {
      name: 'Vijay Teneeru',
      designation: 'Sr. US IT Recruiter',
      image: 'assets/images/team/newdev-images/VijayTeneeru.jpg',
      linkedin: 'https://www.linkedin.com/in/vijay-tanneeru-50a914108/',
      empId:'268'
    },
    // {
    //   name: 'Karuna Midithireddy',
    //   designation: 'Jr. Application Developer',
    //   image: 'assets/images/team/newdev-images/karuna.png',
    //   linkedin: 'https://www.linkedin.com/in/karuna-sweetie-05aa38251/',
    //   empId:'249'
    // },
    // {
    //   name: 'Dhanushma Kumpati',
    //   designation: 'Jr. Application Developer',
    //   image: 'assets/images/team/newdev-images/dhanushma.png',
    //   linkedin: 'https://www.linkedin.com/in/kumpati-dhanushma-57a05a272/',
    //   empId:'253'
    // },
    {
      name: 'Goli Manu Kumar',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Manu.jpg',
      linkedin: 'https://www.linkedin.com/in/ashok-vangala-2b9a4791/?originalSubdomain=in',
      empId:'236'
    },
    {
      name: 'Mohammad Gouse',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Gouse.jpg',
      linkedin: 'https://www.linkedin.com/in/mohammad-gouse-5b8b46250/',
      empId:'211'
    },
    {
      name: 'Shaik Nasima',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Nasima.jpg',
      linkedin: 'https://www.linkedin.com/in/nasima-shaik-698287272/',
      empId:'255'
    },
    {
      name: 'Suhaid Aslam',
      designation: 'RFP Writer',
      image: 'assets/images/team/newdev-images/suhaid.jpg',
      linkedin: '#',
      empId:'256'
    },
    {
      name: 'Akhil Gollapalli',
      designation: 'Software Quality Engineer',
      image: 'assets/images/team/development/default.jpg',
      linkedin: '#',
      empId:'156'
    },
    // {
    //   name: 'Mohammed Salman shaikh',
    //   designation: 'Business Development Executive',
    //   image: 'assets/images/team/newdev-images/salmanshaik.jpg',
    //   linkedin: '#',
    //   empId:'268'
    // },
    {
      name: 'Ashok Palla',
      designation: 'Sr. Application Developer',
      image: 'assets/images/team/newdev-images/AshokPalla.jpg',
      linkedin: 'https://www.linkedin.com/in/ashok-palla-96ab74217/',
      empId:'259'
    },
    {
      name: 'Niranjan Kumar Mukkara',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Niranjankumar.jpg',
      linkedin: 'https://www.linkedin.com/in/niranjan-kumar-mukkara-9a4583275',
      empId:'248'
    },
    {
      name: 'Nanda Kishore Gundapu',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Nandha Kishore.jpeg',
      linkedin: 'https://www.linkedin.com/in/nanda-kishore-b014a027b/',
      empId:'261'
    },
    {
      name: 'Devi Prasanna Kumar reddy Guddeti',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Devi Prasanna.jpg',
      linkedin: 'linkedin.com/in/kumar-reddy-8a6200240',
      empId:'251'
    },
    {
      name: 'Jyothi Sai Siddartha Kusunuri',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Jyothi Sai Siddartha.jpg',
      linkedin: 'linkedin.com/in/siddartha-kusunuri-46237b276',
      empId:'262'
    },
    // {
    //   name: 'Sai Kiranmayi Grandhi',
    //   designation: 'Application Developer',
    //   image: 'assets/images/team/newdev-images/Kiranmayi.jpg',
    //   linkedin: 'https://www.linkedin.com/in/sai-kiranmayi-grandhi-14963a1b1',
    //   empId:'268'
    // }
    {
      name: 'Jahnavi Chunduri',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Jahnavi.jpg',
      linkedin: '',
      empId:'265'
    },
    // {
    //   name: 'Sasi Kumar Gogam',
    //   designation: 'Jr. Application Developer',
    //   image: 'assets/images/team/newdev-images/Sasi G.jpg',
    //   linkedin: '',
    //   empId:'268'
    // },
    {
      name: 'Praveen Kurukuri',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Praveen K.jpg',
      linkedin: '',
      empId:'268'
    },
    {
      name: 'Venkateswarlu Para',
      designation: 'Jr. Data Analyst',
      image: 'assets/images/team/newdev-images/Venkateswarlu Para.jpg',
      linkedin: '',
      empId:'270'
    },
    {
      name: 'Trisali Yalavarthi',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Trisali Yalavarthi.jpg',
      linkedin: '',
      empId:'269'
    },
    {
      name: 'Anil Kumar Reddy Bannuru',
      designation: 'Jr. Test Engineer',
      image: 'assets/images/team/newdev-images/AnilB.jpg',
      linkedin: '',
      empId:'271'
    },
    {
      name: 'Surendra Reddy Kandula',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Surendra K.jpg',
      linkedin: '',
      empId:'272'
    },
    {
      name: 'Aswiya Anjum Shaik',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Aswiya.jpg',
      linkedin: '',
      empId:'273'
    },
    {
      name: 'Vijaya Kumar Machavarapu',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Vijay.jpg',
      linkedin: '',
      empId:'274'
    },
    {
      name: 'Sai Viswanadhapalli',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/SaiV.jpg',
      linkedin: '',
      empId:'276'
    },
    {
      name: 'Bhargavi Ardhalapudi',
      designation: 'Jr. Data Analyst',
      image: 'assets/images/team/newdev-images/Bhargavi.jpg',
      linkedin: '',
      empId:'275'
    },
    {
      name: 'Sirisha Narala',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Sirisha.jpg',
      linkedin: '',
      empId:'278'
    },
    {
      name: 'Naresh Vunnam',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/NareshV.jpg',
      linkedin: '',
      empId:'279'
    },
    {
      name: 'Kavya Mandapati',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Kavya.jpg',
      linkedin: '',
      empId:'281'
    },
    {
      name: 'Siva Nageswararao Velaga',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Siva Nageswararao.jpg',
      linkedin: '',
      empId:'280'
    },
    {
      name: 'Rosi Reddy Atchala',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/newdev-images/Rosi.jpg',
      linkedin: '',
      empId:'282'
    },
    {
      name: 'Vishal Roy Mallela',
      designation: 'Jr. Test Engineer',
      image: 'assets/images/team/newdev-images/Vishal Roy.jpg',
      linkedin: '',
      empId:'283'
    },
    {
      name: 'Abdul Aslam Nawaz Mohammed',
      designation: 'Application Developer',
      image: 'assets/images/team/development/default.jpg',
      linkedin: '',
      empId:'287'
    },
    {

 
      name: 'Sathish Chandra Mallela',
      designation: 'Jr. Application Developer',
      image: 'assets/images/team/development/default.jpg',
      linkedin: '',
      empId:'285'
    },
    {
      name: 'Venkatesh Gopalam',
      designation: 'Jr. Cloud Engineer',
      image: 'assets/images/team/development/default.jpg',
      linkedin: '',
      empId:'286'
    },
  ];
  getTeamMembers(): Observable<any[]> {
    return of(this.teamData);
  }

}
